import {useSelector} from "react-redux";
import {get} from "lodash";
import {getAllProperties} from "../../../../redux/Selectors/controllers.selectors";

export const useReadySystem = () => {
  const systemProperties = useSelector(getAllProperties);
  return get(systemProperties, "state.is_ready");
};

export const summaryDetailsKeys = (summaryDetails) => Object.keys(summaryDetails);
